(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["register-dog-modal"] && !Shopify.designMode) return;
  try {
    const modal = document.getElementById('register-dog-modal');
  const openButtons = document.querySelectorAll('[data-open-register-dog]');
  const closeButton = modal?.querySelector('.register-dog-modal__close');
  const overlay = modal?.querySelector('.register-dog-modal__overlay');

  if (modal && openButtons.length) {
    // Open modal
    openButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        modal.classList.add('show');
        modal.removeAttribute('hidden');
      });
    });

    // Close modal
    [closeButton, overlay].forEach(el => {
      el?.addEventListener('click', () => {
        modal.classList.remove('show');
        modal.setAttribute('hidden', '');
      });
    });

    // Prevent clicks inside modal content from closing it
    modal.querySelector('.register-dog-modal__content')?.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
